import { render } from "./user-layout2.vue?vue&type=template&id=1b232100&scoped=true&ts=true"
import script from "./user-layout2.vue?vue&type=script&lang=ts"
export * from "./user-layout2.vue?vue&type=script&lang=ts"

import "./user-layout2.vue?vue&type=style&index=0&id=1b232100&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b232100"]])

export default __exports__